// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__uBuuY","message":"NotFound_message__j3Cza"};